'use client';

import { getEnvOrFail } from 'env/env';

export const getLoginRedirectUrl = () => {
  const edxLoginEndpoint = getEnvOrFail('NEXT_PUBLIC_EDX_LOGIN_ENDPOINT');
  const url = encodeURIComponent(window.location.href);
  return `${edxLoginEndpoint}?next=${url}`;
};
